import { finishOAuthLoginFromUrl } from '@/lib/auth/finish-oauth-login';
import { useLayoutEffect } from 'react';

const SocialLogin = () => {
  useLayoutEffect(() => {
    void finishOAuthLoginFromUrl();
  }, []);

  return null;
};

export default SocialLogin;
